import PropTypes from "prop-types";
import ResetScopeDialog from "./ResetScopeDialog";
export default function ResetEDSDialog({
  open,
  onClose,
  onConfirm,
  readerGroups,
  resetEDSLoading = false,
  edsResetProgress,
}) {
  return (
    <ResetScopeDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Reiniciar readers EDS"
      scope="Grupos EDS"
      skipWaiting
      readers={readerGroups
        .filter((group) => group.name?.toUpperCase().startsWith("EDS"))
        .flatMap((group) => group.readers || [])}
      loading={resetEDSLoading}
      progress={edsResetProgress}
    />
  );
}
ResetEDSDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  readerGroups: PropTypes.array.isRequired,
  resetEDSLoading: PropTypes.bool,
  edsResetProgress: PropTypes.object,
};
